<!-- template -->
<template>
  <div class="user__page">
    <div class="item__row item__ac">
      <a class="mr-2" @click="clearData">Шығу</a>
      <a  href="https://halalsogym.kz">Сайт</a>
    </div>

    <p class="user__page__title">Сізге жиналған бонус: {{ userBonus }}</p>
    <span class="user__page__info" >ℹ️ Бонусты пайдалану үшін номер телефоныңызды сатушыға айтыңыз</span>

    <p class="user__page__title">Сіздің тапсырыстарыңыз:</p>


    <div class="orders">

        <div class="orders__item order-2" v-for="(order,index) in orders" :key="index" >

            <p><span class="orders__item--key">Адрес: </span> {{ order.address }}</p>
            <div class="orders__item--inner" v-for="item in order.orders" :key="item.id">
               <p><span class="orders__item--key">🍽</span> {{ item.name }} </p>
               <p><span class="orders__item--key">Бағасы: </span> {{ item.price  }} тнг </p>
            </div>

            <p><span class="orders__item--key">Дата: </span> {{ convert_date(order.created_at) }}</p>
        </div>
    </div>


  </div>
</template>

<!-- scripts -->
<script>

export default {
  data() {
    return {
      userBonus: '',
      orders: [],
      phone_number: ''
    };
  },
  mounted() {
    this.phone_number = localStorage.getItem('phone_number') ? localStorage.getItem('phone_number') : this.$router.push('/user/login')
    this.getUserBonus()
    this.getUserOrders()
  },
  methods: {
    convert_date(date) {
      if (date) {
        let day = date.split("T")[0].split("-")[2];
        let month = date.split("T")[0].split("-")[1];
        let year = date.split("T")[0].split("-")[0];

        let hour = date.split("T")[1].split(":")[0];
        let minute = date.split("T")[1].split(":")[1];
        let ready = day + "." + month + "." + year;

        return ready + " " + hour + ":" + minute;
      }
    },
    clearData() {
      localStorage.setItem('phone_number','')
      this.$router.push('/')
    },
     getUserBonus() {
       this.$http
           .get(
               "/get/bonus?phone=" +
               this.phone_number
           )
           .then((res) => {
             if (res.data.bonus) {
               if (res.data.bonus === "zero") {
                 this.bonus = "0 тг"
               } else {
                 this.userBonus = res.data.bonus+" тнг"
               }
             } else {
               this.bonus = res.data.message;
             }
           });
     },
     getUserOrders() {
       this.$http
           .get(
               "/get/orders/by/phone?phone=" +
               this.phone_number
           )
           .then((res) => {
              this.orders = res.data
           });
     }
  },
};
</script>

<style scoped lang="scss">
.user__page {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .user__page__info {
    font-size: 10px;
  }
  @media only screen and (max-width: 764px) {
    width: 100%;
  }
  .user__page__title {
    margin-bottom: 3px;
    font-weight: bold;
    font-size: 18px;
    color: #333;
    @media only screen and (max-width: 900px) {
      font-size: 16px;
    }
  }
  .user__page__block {
    display: flex;
    flex-direction: column;
    input {
      width: 300px;
      padding: 20px;
      margin-bottom: 20px;
      border: 1px solid #ccc;
      @media only screen and (max-width: 764px) {
        width: 100%;
      }
    }
    ::placeholder {
      color: #333;
    }
    button {
      cursor: pointer;
      text-transform: uppercase;
      width: 300px;
      outline: none;
      border: none;
      background-color: cornflowerblue;
      padding: 20px;
      @media only screen and (max-width: 764px) {
        width: 250px;
      }
      p {
        color: white;
        font-weight: bold;
        margin-bottom: 0;
      }
    }
    button:hover {
      background-color: #285bb6;
    }
  }
}

.orders {
  .orders__item {
    margin-bottom: 20px;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
    padding: 20px;
    border-radius: 10px;
    min-width: 350px;
    .orders__item--inner {
      margin-bottom: 10px;
      border: 1px solid black;
      padding: 5px;
      border-radius: 10px;
    }
  }
}
.orders__item--key {
  font-weight: bold;
}
</style>
